(function () {
  console.log('[VARIANT-CARD] Script iniciado – aguardando variant-btns');

  function initVariantCardQuickAdd() {
    const buttons = document.querySelectorAll('.variant-btn:not(.initialized)');
    if (buttons.length === 0) {
      console.warn('[VARIANT-CARD] Nenhum botão encontrado ainda.');
      return;
    }

    console.log(`[VARIANT-CARD] ${buttons.length} botões detectados.`);

    buttons.forEach((btn) => {
      const id = btn.dataset.variantId;
      const label = btn.textContent.trim();

      if (btn.classList.contains('initialized')) return;
      btn.classList.add('initialized');

      console.log(`[VARIANT-CARD] Bind do botão: ${label} → ID ${id}`);

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (btn.classList.contains('is-disabled') || btn.classList.contains('loading')) {
          return;
        }

        btn.classList.add('loading');

        try {
          const payload = { items: [{ id: parseInt(id), quantity: 1 }] };
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (!res.ok) throw new Error(`Erro ${res.status}`);
          const data = await res.json();

          console.log('[VARIANT-CARD] ✅ Produto adicionado:', data);
          updateCartCountBubble();
          showVariantToast();

          // Evita redirecionar ou atualizar a página do carrinho se já estiver nela
          if (window.location.pathname === '/cart') {
            console.log('[VARIANT-CARD] Já na página do carrinho – evitando reload');
          }

        } catch (err) {
          console.error('[VARIANT-CARD] ❌ Falha ao adicionar produto:', err);
        } finally {
          btn.classList.remove('loading');
        }
      });
    });
  }

  setTimeout(initVariantCardQuickAdd, 1000);

  const observer = new MutationObserver(() => {
    const btns = document.querySelectorAll('.variant-btn:not(.initialized)');
    if (btns.length > 0) {
      console.log('[VARIANT-CARD] Observador ativado: novos botões encontrados.');
      initVariantCardQuickAdd();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

function updateCartCountBubble() {
  if (window.location.pathname === '/cart') return; // Evita reprocessar se já estiver no carrinho

  fetch(window.Shopify.routes.root + 'cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const count = cart.item_count;
      const cartCountEls = document.querySelectorAll('[data-cart-count]');
      console.log(`[VARIANT-CARD] 🛒 Atualizando contador do carrinho para: ${count}`);

      cartCountEls.forEach((el) => {
        el.textContent = count;
      });
    })
    .catch((err) => {
      console.error('[VARIANT-CARD] ❌ Falha ao atualizar contador do carrinho:', err);
    });
}

function showVariantToast() {
  const toast = document.getElementById('variant-toast');
  if (!toast) return;

  toast.classList.remove('hidden');
  toast.classList.add('show');

  setTimeout(() => {
    toast.classList.remove('show');
    toast.classList.add('hidden');
  }, 2000);
}

// Injeta o toast se ainda não existir
if (!document.getElementById('variant-toast')) {
  const toast = document.createElement('div');
  toast.id = 'variant-toast';
  toast.className = 'variant-toast hidden';
  toast.textContent = 'Produto adicionado ao carrinho!';
  document.body.appendChild(toast);
}
